<template>
    <div>

        <rkm-form
            ref="FormSalarioMinimo"
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-input
                        label="Salário mínimo"
                        :validations="validations.salarioMinimo"
                        v-model="model.salarioMinimo"
                        type="number"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

export default {
    created() {

        this.model.salarioMinimo = this.data.model.outros.salarioMinimo.salarioMinimo
    },
    computed: {
        validations() {
    
            return {
                salarioMinimo: {
                    required: true,
                    min: 1,
                    max: 7,
                }
            }
        },
    },
    data: () => ({
        model: {
            salarioMinimo: null,
        },
        form: null,
    }),
    methods: {
        async validate() {

            return true
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    },
    watch: {
        'model.salarioMinimo': function(valor) {

            if (valor < 0) {

                this.model.salarioMinimo = null
            }

            this.data.model.outros.salarioMinimo.salarioMinimo = this.model.salarioMinimo
        },
    },
}
    
</script>